import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Select, Checkbox, Tooltip, Icon, message } from 'antd';
import TableC from '../../../basicElement/TableC';
import Text from '../../../basicElement/Text';
import ExportUtil from '../../../../common/ExportUtil';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import deepClone from '../../../shared/deepClone';
import { Default, RelateType } from '../constants';

const { Option } = Select;
const Tip = (
    <div>
        准确关联：合同为该中心已签署完成的实际合同；<br />
        临时关联：若该中心暂无实际合同，可临时借用<br />
        关联其他JDE，待该中心实际合同签署完成后，<br />
        请及时修改该中心的准确关联合同；
    </div>
);

const genOptions = data => Object.keys(data).map(i => <Option key={i} value={i}>{ data[i] }</Option>);

const RelateTypeOption = genOptions(RelateType);

class RelateJdeCode extends Component {
    static contextTypes = {
        contractList: PropTypes.array,
    }

    state = {
        visible: false,
        loading: false,
        selected: [],
    }

    investigationSiteId = ''

    show = (selected, investigationSiteId) => {
        this.investigationSiteId = investigationSiteId;
        this.setState({
            selected: selected ? deepClone(selected) : [],
            visible: true,
        });
    }

    hide = () => {
        this.investigationSiteId = '';
        this.setState({
            selected: [],
            visible: false,
        });
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    handleChange = (value, investigationJdeContractId, type) => {
        const { selected } = this.state;
        const matched = selected.find(s => s.investigationJdeContractId == investigationJdeContractId);
        matched[type] = value;
        this.setState({ selected });
    }

    handleSelect = (e) => {
        let { selected } = this.state;
        const { contractList } = this.context;
        const { value, checked } = e.target;
        if (checked) {
            const matched = contractList.find(i => i.investigationJdeContractId == value);
            selected.push({ ...matched });
            selected.sort((a, b) => a.investigationJdeContractId - b.investigationJdeContractId);
        } else {
            selected = selected.filter(i => i.investigationJdeContractId != value);
        }
        this.setState({ selected });
    }

    handleSelectAll = () => {
        let { selected } = this.state;
        const { contractList } = this.context;
        const selectAll = contractList.every(i => selected.some(s => s.investigationJdeContractId == i.investigationJdeContractId));
        if (selectAll) {
            selected = [];
        } else {
            selected = contractList.map(item => {
                const matched = selected.find(i => i.investigationJdeContractId == item.investigationJdeContractId);
                return matched ? {...matched} : {...item};
            });
        }
        this.setState({ selected });
    }

    getColumns = () => {
        const { selected } = this.state;
        const { contractList } = this.context;
        const selectAll = contractList.every(i => selected.some(s => s.investigationJdeContractId == i.investigationJdeContractId));
        const columns = [{
            title: (
                <div>
                    <Checkbox style={{ marginRight: 4 }} checked={selectAll} onChange={this.handleSelectAll} />
                    全选
                </div>
            ),
            dataIndex: 'index',
            key: 'index',
            width: 60,
            render: (text, record, index) => {
                const { investigationJdeContractId } = record;
                const checked = selected.some(s => s.investigationJdeContractId == investigationJdeContractId);
                return (
                    <div style={{ textAlign: 'center' }}>
                        <Checkbox checked={checked} value={investigationJdeContractId} onChange={this.handleSelect} />
                    </div>
                );
            }
        }, {
            title: (
                <div>
                    <Text asterisk={true} colon={false}>关联类型</Text>
                    <Tooltip overlayClassName="downloadSite" placement="top" title={Tip}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </div>
            ),
            dataIndex: 'relatedType',
            key: 'relatedType',
            width: 100,
            render: (text, record, index) => {
                const { investigationJdeContractId } = record;
                const matched = selected.find(s => s.investigationJdeContractId == investigationJdeContractId);
                const checked = !!matched;
                const value = checked ? matched.relatedType || undefined : undefined;
                return (
                    <Select
                        disabled={!checked}
                        allowClear={true}
                        placeholder="请选择"
                        style={{ width: 80 }}
                        value={value}
                        onChange={value => this.handleChange(value, investigationJdeContractId, 'relatedType')}
                    >
                        { RelateTypeOption }
                    </Select>
                );
            }
        }, {
            title: 'JDE建号申请编号',
            dataIndex: 'jdeApplyCode',
            key: 'jdeApplyCode',
            width: 120,
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 100,
        }, {
            title: '合同附件/提前上岗授权函',
            dataIndex: 'contractAttachment',
            key: 'contractAttachment',
            width: 200,
            render: (text, record) => {
                const { files } = record;
                return (files || []).map(i => <a key={i.id} onClick={e => this.downLoadFile(e, i.id)}>{i.name}<br /></a>);
            }
        }, {
            title: '合同主键',
            dataIndex: 'investigationJdeContractId',
            key: 'investigationJdeContractId',
            width: 80,
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
            width: 80,
        }, {
            title: '是否签署完成',
            dataIndex: 'investigationJdeContractIsSigned',
            key: 'investigationJdeContractIsSigned',
            width: 100,
            render: (text, record) => {
                return Default[text];
            }
        }, {
            title: '合同额含税/人民币(元)',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '合同开始时间',
            dataIndex: 'startTime',
            key: 'startTime',
            width: 100,
            render: text => format('date', text),
        }, {
            title: '合同结束时间',
            dataIndex: 'endTime',
            key: 'endTime',
            width: 100,
            render: text => format('date', text),
        }];
        return columns;
    }

    confirm = () => {
        const { selected } = this.state;
        const params = {};

        console.log(selected);
        for (let i = 0, len = selected.length; i < len; i++) {
            const { contractType, relatedType, investigationJdeContractId } = selected[i];

            if (!relatedType) {
                return message.warning('请选择关联类型！');
            }

            params[`contractSites[${i}].investigationJdeContractId`] = investigationJdeContractId;
            params[`contractSites[${i}].contractType`] = contractType;
            params[`contractSites[${i}].relatedType`] = relatedType;
        }
        if (!Object.keys(params).length) {
            return message.warning('请选择关联类型！');
        }

        if (!this.investigationSiteId) {
            this.props.onChange(selected);
            this.hide();
        } else {
            this.setState({ loading: true });
            const options = {
                url: API_URL.site.relatedSiteAndContractById,
                data: {
                    ...params,
                    investigationSiteId: this.investigationSiteId
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.hide();
                    this.setState({ loading: false }, () => {
                        this.props.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            };
            $.sendRequest(options);
        }
    }

    render() {
        const { visible, loading } = this.state;
        const { contractList } = this.context;
        return (
            <Modal
                title="选择JDE项目号"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                bodyStyle={{ maxHeight: 500 }}
                confirmLoading={loading}
                maskClosable={false}
                width="1200px"
            >
                <div style={{ padding: 10 }}>
                    <TableC
                        columns={this.getColumns()}
                        data={contractList}
                        rowKey="investigationJdeContractId"
                        className="RelateJdeCode"
                    />
                </div>
            </Modal>
        );
    }
}

export default RelateJdeCode;


// WEBPACK FOOTER //
// ./src/components/site/researchCenterDetail/components/RelateJdeCode.js